<template>
  <div class="payment-information mt-5 lg:mt-10">
    <the-section :title="$t('ec-line004.paymentInformation.title')">
      <amapay-brand
        v-if="data.payment_method === Constants.PAYMENT_METHOD.AMAZON"
        :amazon-card="data.amazon_card"
      ></amapay-brand>
      <el-form v-else ref="payment-form" class="payment-information__form" label-position="top">
        <el-form-item :label="$t('common.memberInformation.paymentMethod')">
          <disabled-input :value="paymentMethod" />
        </el-form-item>
        <div v-if="data.payment_method === Constants.PAYMENT_METHOD.CREDIT_CARD">
          <div v-if="data.security_code && !isCardNumberMasked(data.card_number)">
            <el-form-item :label="$t('ec-line004.paymentInformation.cardNumber')">
              <disabled-input :value="data.card_number" />
            </el-form-item>
            <el-form-item :label="$t('ec-line004.paymentInformation.dateOfExpired')">
              <el-row :gutter="6" type="flex">
                <el-col class="flex-1" :span="11">
                  <el-form-item class="w-full" prop="paymentInformation.dateOfExpiredMonth">
                    <disabled-input :value="data.card_month" />
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <div class="text-center">{{ $t('common.dateSeparator') }}</div>
                </el-col>
                <el-col class="flex-1" :span="11">
                  <el-form-item class="w-full" prop="paymentInformation.dateOfExpiredYear">
                    <disabled-input :value="data.card_year" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item :label="$t('ec-line004.paymentInformation.cardHolder')">
              <disabled-input :value="data.card_holder" />
            </el-form-item>
            <el-form-item :label="$t('ec-line004.paymentInformation.securityCode')">
              <disabled-input :value="maskedSecurityCode" />
            </el-form-item>
            <el-form-item :label="$t('ec-line004.paymentInformation.numberOfPayment')">
              <disabled-input :value="getNumberOfPaymentLabel(data.number_of_payment)" />
            </el-form-item>
          </div>
          <div v-else class="payment-information__card">
            <span class="font-bold text-base">{{ Utils.helper.formatCard(data.card_number) }}</span>
            <span class="text-base">{{
              $t('common.cardExpired', { month: data.card_month, year: data.card_year })
            }}</span>
          </div>
        </div>
      </el-form>
    </the-section>
  </div>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import DisabledInput from '@/components/DisabledInput.vue'
import AmapayBrand from '@/components/AmapayBrand.vue'
import mixinRegisterCustomer from '@/mixins/register-customer'

export default {
  components: { TheSection, DisabledInput, AmapayBrand },
  props: {
    data: { type: Object, default: () => {} },
  },
  mixins: [mixinRegisterCustomer],
  computed: {
    paymentMethod() {
      return this.$store.state.register.paymentMethods?.find(
        (method) => method.payment_service_id === this.data.payment_method
      )?.payment_method
    },
    maskedSecurityCode() {
      return this.data.security_code ? '*'.repeat(this.data.security_code.length) : '***'
    },
  },
  methods: {
    isCardNumberMasked(cardNumber) {
      const maskedPattern = /^\*+(\d{4})$/
      return maskedPattern.test(cardNumber)
    },
    getNumberOfPaymentLabel(value) {
      const payment = this.numberOfPayments.find((option) => option.value === value)
      return payment ? payment.label : ''
    },
  },
}
</script>
